export const environment = {
  production: false,
  apiURL: 'https://devapi.raffle-rocket.com/api',
  hubURL: 'https://devapi.raffle-rocket.com/raffle',
  clientURL: 'https://qago.raffle-rocket.com',
  cbsDashUrl: 'https://qamanage.communibee.ca',
  cbsAPIUrl: 'https://devapi.launch57.com/cbs/api',
  bbClientUrl: 'https://qaapp.bidbeacon.com/',
  gtmId: 'GTM-KWQK9G2'
};
